import { render, staticRenderFns } from "./enquiryDetail.vue?vue&type=template&id=156e7d68&scoped=true"
import script from "./enquiryDetail.vue?vue&type=script&lang=js"
export * from "./enquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./enquiryDetail.vue?vue&type=style&index=0&id=156e7d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e7d68",
  null
  
)

export default component.exports